module.exports = __webpack_public_path__ + "img/41a2fe9.jpg";